import translation from "./translation.json";

type TranslationType = { [key: string]: { [key: string]: string | undefined } };

/**
 * Retrieves the translation for a given key based on the current locale.
 * @param key - The key for which the translation is needed.
 * @returns The translated string or "N/A" if the key is not found.
 */
export const getTranslation = (locale: string, key: string): string => {
  const t: TranslationType = translation;

  // Check if the translation for the given key exists
  if (t[key] === undefined) {
    // Returning "N/A" if the translation key is not found
    return "N/A";
  }

  // Return the translation for the current locale
  return t[key][locale] ?? "N/A";
};
